import React, { Component } from 'react';
import { DASHBOARD_SCREEN } from '../../global/Constants';
import { DashboardType } from '../../global/Enum';

class DashboardTehsils extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isUpdate: false,
            selectedTehsil: '',
            tehsilPercent: 0,
            totalTehsil: 0,
            activeTehsil: 0
        }
    }

    componentDidMount() {
        const { tehsil } = this.props;
        if (tehsil) {
            let total = tehsil?.tehsil_detail[0]?.total_activity;
            let active = tehsil?.tehsil_detail[0]?.completed_activity;
            let percent = this.getTehsilValuePercent(total, active);
            this.setState({
                tehsilPercent: percent,
                totalTehsil: total,
                activeTehsil: active
            });
        }
    }

    componentDidUpdate(prevState, prevProps) {
        if (prevProps.tehsil !== this.props.tehsil) {
            if (!this.state.isUpdate) {
                const { tehsil } = this.props;
                if (tehsil) {
                    let total = tehsil?.tehsil_detail[0]?.total_activity;
                    let active = tehsil?.tehsil_detail[0]?.completed_activity;
                    let percent = this.getTehsilValuePercent(total, active);
                    //this.forceUpdate();
                    this.setState({
                        tehsilPercent: percent,
                        totalTehsil: total,
                        activeTehsil: active,
                        isUpdate: true
                    });
                }
            }
        }
    }

    getActiveTehsilsPercent() {
        const { tehsil } = this.props;
        let totalTehsil = tehsil?.total_tehsil;
        if (totalTehsil > 0) {
            let activeTehsil = tehsil.active_tehsil;
            const percent = (activeTehsil * 100) / totalTehsil;
            return Math.round(percent) + "%";
        } else {
            return 0 + "%";
        }
    }

    getTehsilValuePercent(total, active) {
        const percent = (active * 100) / total;
        return Math.round(percent);
    }

    handleChange = ({ target }) => {
        const { tehsil } = this.props;
        const tehsilObj = tehsil?.tehsil_detail.find(item => item.tehsil_name === target.value);
        let percent = this.getTehsilValuePercent(tehsilObj.total_activity, tehsilObj.completed_activity);
        this.setState({
            tehsilPercent: percent,
            totalTehsil: tehsilObj.total_activity,
            activeTehsil: tehsilObj.completed_activity
        })
    }

    render() {
        const { tehsil, activeTab } = this.props;
        const { totalTehsil, activeTehsil } = this.state;

        if (tehsil) {
            return (
                <div id="tehsils" className={activeTab === DashboardType.TEHSILS ? "more-menu-body" : "d-none"}>
                    <h6 className="font-weight-medium d-flex">{DASHBOARD_SCREEN.ACTIVE_TEHSILS}
                        <span className="ml-auto">{tehsil?.active_tehsil}/{tehsil?.total_tehsil}</span>
                    </h6>
                    <div className="progress progress-red1 mb-3">
                        <div className={`progress-bar ${tehsil?.total_tehsil === 0 ? "progress-padding" : ''} `} role="progressbar" style={{ width: this.getActiveTehsilsPercent() }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                            {this.getActiveTehsilsPercent()}
                        </div>
                    </div>
                    <div className={`form-group ${tehsil?.tehsil_detail?.length === 0 ? 'd-none' : ''}`}>
                        <select className="form-control"
                            onChange={this.handleChange}>
                            {
                                tehsil.tehsil_detail.map((item, i) =>
                                    <option key={i} value={item.tehsil_name} >{item.tehsil_name}</option>)
                            }
                            {/* <option value="">Tehsils One</option>
                            <option value="">Tehsils Two</option>
                            <option value="">Tehsils Three</option> */}

                        </select>
                    </div>

                    <div className={`gray-bg bdr-radius-7 p-3 ${tehsil?.tehsil_detail?.length === 0 ? 'd-none' : ''}`}>
                        <div className="progress circle-progress" data-percentage={this.state.tehsilPercent}>
                            <span className="progress-left">
                                <span className="progress-bar"></span>
                            </span>
                            <span className="progress-right">
                                <span className="progress-bar"></span>
                            </span>
                            <div className="progress-value">
                                <div className="text-white">{activeTehsil}/{totalTehsil}</div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return null;
        }

    }
}

export default DashboardTehsils;
